import React from 'react'
import { Image } from 'react-bootstrap';
import lekeTedavisi from '../../images/home/taniTedavi/16001728962916.jpg';
import '../../styles/about.css'

const TaniTedavi5 = () => {
    return (
        <div>
            <h5 className='main-title'>ELEKTRO KOTERİZASYON</h5>
            <hr />
            <p>5</p>
            <p>Deri lezyonlarının elektrik enerjisi kullanılarak ısı enerjisi oluşturmak suretiyle tedavi edilmesidir.</p>
            <p>Deride oluşabilen siğil, saplı fibroma, keratoz, spider angioma, cherry angioma gibi lezyonlar lokal anestezi altında, elektrik akımı yardımıyla bir kerede ve kısa sürede tedavi edilebilirler. Tedavinin kısa süreli olması ve deride genellikle kalıcı hasar bırakmaması önemli özelliğidir.</p>
            <Image src={lekeTedavisi} fluid className='mb-4' style={{ width: '70%' }} />
            <p>Elektrokoter, elektrik enerjisinin ısıya dönüştürülmesi sonucu deriden kabarık lezyonların yakılması ve yok edilmesi esasına dayanır. En eski tedavilerde dağlama olarak kullanılmaktaydı. Şimdi, çift kutuplu, doğru akımla çalışan bir cihazla elektrokoagülasyon (kanama durdurma) ve elektrodesikasyon (kesme) işlemleri şeklinde uygulanmaktadır.</p>
            <p>Siğiller, seboreik keratoz, piyojenik granülom gibi kabarıklık yapan bir çok deri hastalığında aynı esaslarda uygulanan bir tedavidir.</p>
        </div>
    )
}

export default TaniTedavi5